export const CASH_DESK_MODULE = 'CASH_DESK'

export const businessScopeConfig = [
	{ businessScope: 'PICKUP', title: 'Settings.pickup' },
	{ businessScope: 'COUNTER', title: 'Settings.counter' },
]
